<div class="w-full flex flex-col gap-4 justify-center p-4" id="bg">
    <form
        class="w-full sm:max-w-md bg-white sm:min-h-[60%] rounded-lg flex flex-col gap-6 p-4 md:ml-6 shadow-2xl shadow-black justify-center items-center"
        [formGroup]="form"
        (submit)="logarUsuario()"
    >
        <img
            src="assets/images/icone.png"
            alt="Ícone"
            class="w-24 h-24 object-contain"
        />

        <app-input
            class="w-full md:max-w-80"
            label="Usuário"
            placeholder="Usuario"
            formControlName="User"
        ></app-input>

        <app-input
            type="password"
            class="w-full md:max-w-80"
            label="Senha"
            placeholder="Senha"
            formControlName="Password"
        ></app-input>

        <button
            type="submit"
            class="cursor-pointer w-full md:max-w-80 bg-green-600 text-white rounded-lg p-2 hover:bg-green-700 transition-colors"
        >
            Entrar
        </button>
    </form>
</div>
